import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import {
  UpdateOnsiteWorker,
  UpdateOnsiteWorkerVariables,
} from '../../../athena/types/UpdateOnsiteWorker';

export const MUTATION = gql`
  mutation UpdateOnsiteWorker($maintenanceRequestId: String!, $memberToken: String!) {
    webMaintenance {
      updateOnsiteWorker(
        input: { maintenanceRequestId: $maintenanceRequestId, memberToken: $memberToken }
      ) {
        _empty
      }
    }
  }
`;

export const useUpdateOnsiteWorker = () => {
  return useMutation<UpdateOnsiteWorker, UpdateOnsiteWorkerVariables>(MUTATION);
};
